<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import groupBy from "lodash/groupBy";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import Details from "@/router/views/dts/dts-modal/details";
import Logs from "@/router/views/dts/dts-modal/logs";
import Rating from "@/router/views/dts/dts-modal/satisfactory-rating";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";

export default {
  page: {
    title: "Incoming Tracks"
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DatePicker,
    Details,
    Logs,
    Rating,
    PrintOptions,
    RawData,
    AttachmentModal
  },
  data() {
    return {
      title: "Incoming Tracks",
      submitted: false,
      submittedDocument: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Office Tracks",
          href: "/dts/office-tracks"
        },
        {
          text: "Incoming Tracks",
          active: true
        }
      ],
      modalTitle: "",
      tableData: [],
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      perPageItem: 10,
      currentPageForm: 1,
      loading: false,
      form: {
        parentId: 0,
        deliveryUnitId: "",
        departmentId: "",
        title: "",
        description: "",
        destinationCampus: null,
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        requestedAction: "",
        actionTaken: ""
      },
      formRemarks: {
        id: "",
        deliveryUnitId: "",
        departmentId: "",
        actionTaken: ""
      },
      formNotes: {
        id: "",
        stringData: ""
      },
      processedDateRange: "",
      uploadTitle: "",
      dateRangeIndex: 0,
      forwardType: "",
      campusOptions: [],
      departmentOptions: [],
      processTypeOptions: [],
      actionTypeOptions: [],
      formLoading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU.id,
      selectedDepartment: this.$store.state.data.selectedDepartment.id,
      viewDetailsUser: "incoming",
      tabIndex: 0,
      tableSort: {
        sortBy: "",
        trackReverse: true,
        processReverse: false,
        durationReverse: false,
        sentByReverse: false
      },
      showAllCampus: false,
      dus: [],
      processTypesDUs: []
    };
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      destinationCampus: { required },
      destinationDeliveryUnit: { required },
      processType: { required },
      actionType: { required },
      documents: { required },
      actionTaken: { required }
    },
    formRemarks: {
      actionTaken: { required }
    },
    formNotes: {
      stringData: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.title) {
            if (item.title.toUpperCase().includes(this.filter.toUpperCase()))
              return item.title
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.description) {
            if (
              item.description.toUpperCase().includes(this.filter.toUpperCase())
            )
              return item.description
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.referenceNumber) {
            if (
              item.referenceNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.referenceNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    }
  },
  watch: {
    "showAllCampus": function(value) {
      this.form.destinationCampus = null;
      this.form.destinationDeliveryUnit = null;
      this.form.destinationDepartment = null;
      this.form.destinationDepartmentId = "";
      if(value){
        this.campusOptions = this.groupDu(this.dus);
      }else{
        this.campusOptions = this.groupDu(this.processTypesDUs);
      }
    },
  },
  created() {
    this.changeCampus();
    this.getAllDUs();
  },
  methods: {
    async getAllDUs() {
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnit")
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.dus = res.data.sort(function(a, b) {
            if (a.name.trim() .trim()< b.name.trim()) {
              return -1;
            }
            if (a.name.trim() > b.name.trim()) {
              return 1;
            }
            return 0;
          }).filter(item => !item.office.campus.campusName.toLowerCase().includes('test')).map((item) => {
            return {
              id: item.id,
              name: item.name.trim(),
              campusId: item.office.campusId,
              campus: item.office.campus.campusName
            };
          });
        })
        .catch((err) => {
          this.showToast("Something went wrong - Getting campuses!", "error");
        });
    },
    changeCampus() {
      this.campusId = this.$store.state.data.selectedCampus.id;
      this.selectedDU = this.$store.state.data.selectedDU.id;
      this.selectedDepartment = this.$store.state.data.selectedDepartment.id;
      if (this.tabIndex == 0) this.getIncoming();
      else if (this.tabIndex == 1) this.getReceived();
      else if (this.tabIndex == 2) this.getProcessed();
    },
    sortData(sortBy) {
      if (sortBy == "track") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.trackReverse = !this.tableSort.trackReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.id < b.id) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.trackReverse) this.tableData.reverse();
      } else if (sortBy == "sentBy") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.sentByReverse = !this.tableSort.sentByReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.deliveryUnit.name < b.deliveryUnit.name) {
            return -1;
          }
          if (a.deliveryUnit.name > b.deliveryUnit.name) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.sentByReverse) this.tableData.reverse();
      } else if (sortBy == "duration") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.durationReverse = !this.tableSort.durationReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData.forEach((item) => {
          item.processDuration = this.processDuration(item);
        });
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.processDuration < b.processDuration) {
            return -1;
          }
          if (a.processDuration > b.processDuration) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.durationReverse) this.tableData.reverse();
      } else if (sortBy == "processType") {
        if (this.tableSort.sortBy == sortBy) {
          this.tableSort.processReverse = !this.tableSort.processReverse;
        } else {
          this.tableSort.sortBy = sortBy;
        }
        this.tableData = this.tableData.sort(function(a, b) {
          if (a.processType.processName < b.processType.processName) {
            return -1;
          }
          if (a.processType.processName > b.processType.processName) {
            return 1;
          }
          return 0;
        });
        if (this.tableSort.processReverse) this.tableData.reverse();
      }
    },
    getIncoming() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        processReverse: false,
        durationReverse: false,
        sentByReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetIncomingTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting incoming tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getReceived() {
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        processReverse: false,
        durationReverse: false,
        sentByReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetReceivedTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting received tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getProcessed() {
      if (
        this.processedDateRange == "" ||
        this.processedDateRange[0] == null ||
        this.processedDateRange[1] == null
      )
        this.setDateRange();
      this.loading = true;
      this.tableSort = {
        sortBy: "",
        trackReverse: true,
        processReverse: false,
        durationReverse: false,
        sentByReverse: false
      };
      this.$store
        .dispatch("dtstrack/GetProcessedTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: 0,
          dateFrom: this.processedDateRange[0],
          dateTo: this.processedDateRange[1]
        })
        .then((res) => {
          this.tableData = res.data;
          this.sortData("track");
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting processed tracks!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    receiveTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to receive this track.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, receive track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/ReceiveTrack", {
              id: props.id,
              deliveryUnitId: this.selectedDU,
              departmentId: 0
            })
            .then(() => {
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.incomingTracks = dashboardData.incomingTracks - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.showToast("Successfully received", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be received!", "error");
            });
        }
      });
    },
    onReturnTrack() {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to return this track.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, return track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/ReturnTrack", this.formRemarks)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == this.formRemarks.id
              );
              this.tableData.splice(index, 1);
              this.$bvModal.hide("modal-returnTrack");
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.incomingTracks = dashboardData.incomingTracks - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.showToast("Successfully returned", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be returned!", "error");
            });
        }
      });
    },
    returnTrack(props) {
      this.onReset();
      this.formRemarks.id = props.id;
      this.$bvModal.show("modal-returnTrack");
    },
    onCompleteTrack() {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to complete this track.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, complete track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/CompleteTrack", this.formRemarks)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == this.formRemarks.id
              );
              this.tableData.splice(index, 1);
              this.$bvModal.hide("modal-completeTrack");
              this.showToast("Successfully Completed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be Completed!", "error");
            });
        }
      });
    },
    completeTrack(props) {
      this.onReset();
      this.formRemarks.id = props.id;
      this.$bvModal.show("modal-completeTrack");
    },
    moveToOfficeDocumments() {
      this.$swal({
        position: "top",
        title: "Completed",
        text: "Successfully Created",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Show Draft Page",
        cancelButtonColor: "#5c636a",
        cancelButtonText: "Close",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push("/dts/office-tracks");
        }
      });
    },
    onForwardTrack(type) {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.form.destinationDeliveryUnitId = this.form.destinationDeliveryUnit.id;
      this.form.destinationDepartmentId = this.form.destinationDepartment.id;
      this.form.processTypeId = this.form.processType.id;
      this.form.actionNeeded = this.form.actionType.type;
      this.$store
        .dispatch("dtstrack/CompleteTrack", {
          id: this.form.parentId,
          deliveryUnitId: this.form.deliveryUnitId,
          departmentId: this.form.departmentId,
          actionTaken: this.form.actionTaken
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.$store
            .dispatch("dtstrack/ForwardTrack", this.form)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var newData = res.data;
              if (type == "create") {
                this.moveToOfficeDocumments();
              } else {
                this.$store
                  .dispatch("dtstrack/PostTrack", newData.id)
                  .then((res) => {
                    if (res.data.error) {
                      return this.showToast(res.data.errorMessage, "error");
                    }
                    this.viewDetails(newData.id, "office");
                    if (this.forwardType == "received") {
                      this.getReceived();
                    }
                  })
                  .catch((err) => {
                    this.showToast("Cannot be sent!", "error");
                  });
              }
              this.$bvModal.hide("modal-documentTrack");
              this.showToast("Successfully forwarded!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        });
    },
    async forwardTrack(props) {
      this.formLoading = true;
      this.modalTitle = "Forward Track";
      this.$bvModal.show("modal-documentTrack");
      this.forwardType = props.type;
      await this.onReset();
      await this.getProcessType(props.data.processTypeId);
      await this.getActionType();
      await this.getDocuments(this.form, props.data.id);
      this.form.parentId = cloneDeep(props.data.id);
      this.form.title = cloneDeep(props.data.title);
      this.form.description = cloneDeep(props.data.description);
      this.form.requestedAction = cloneDeep(props.data.actionNeeded);
      this.formLoading = false;
    },
    onUpdateNotes() {
      this.submitted = true;
      this.$v.formNotes.$touch();
      if (this.$v.formNotes.$invalid) {
        return;
      }
      this.$store
        .dispatch("dtstrack/UpdateNotes", this.formNotes)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          var index = this.tableData.findIndex(
            (item) => item.id == this.formNotes.id
          );
          this.tableData[index].note = this.formNotes.stringData;
          this.$bvModal.hide("modal-updateNotes");
          this.showToast("Successfully saved!", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    updateNotes(props) {
      this.onReset();
      this.formNotes.id = cloneDeep(props.id);
      this.formNotes.stringData = cloneDeep(props.note);
      this.$bvModal.show("modal-updateNotes");
    },
    async onReset() {
      this.submitted = false;
      this.form = {
        parentId: 0,
        deliveryUnitId: this.selectedDU,
        departmentId: 0,
        title: "",
        description: "",
        destinationCampus: null,
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        tracks: [],
        actionTaken: "",
        requestedAction: ""
      };
      this.formRemarks = {
        id: "",
        deliveryUnitId: this.selectedDU,
        departmentId: 0,
        actionTaken: ""
      };
      (this.formNotes = {
        id: "",
        stringData: ""
      }),
        (this.campusOptions = []);
      this.processTypeOptions = [];
      this.actionTypeOptions = [];
    },
    addDocument() {
      if (this.form.document.trim() != "") {
        this.form.documents.push(this.form.document);
        this.form.document = "";
      }
    },
    removeDocument(index) {
      this.form.documents.splice(index, 1);
    },
    async changeProcessType() {
      await this.getDeliveryUnit();
      this.form.actionNeeded = "";
      this.form.actionType = null;
      this.form.destinationDepartmentId = "";
      this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
      this.form.destinationDeliveryUnitId = "";
      this.form.destinationDeliveryUnit = null;
      this.form.destinationCampus = null;
    },
    viewDetails(id, type) {
      this.viewDetailsUser = type ? type : "incoming";
      this.$refs.details.getData(id);
    },
    viewLogs(id) {
      this.$refs.logs.getData(id);
    },
    async viewAttachments(item) {
      this.uploadTitle = `${item.title} Attachments`;
      this.$refs.attachmentModal.setUploadOpt({
        type: `DTS Tracks`,
        placement: "left",
        folder: "DTS"
      });
      this.$refs.attachmentModal.getData(item.id);
      this.$bvModal.show("upload-attachment-modal");
    },
    trackRating(trackId) {
      this.$refs.rating.setRating(trackId, this.selectedDU);
    },
    saveRating(trackId) {
      var index = this.tableData.findIndex((item) => item.id == trackId);
      this.tableData[index].withRating = true;
    },
    async getDocuments(props, id) {
      this.$store
        .dispatch("dtstrackdocument/GetTrackDocument", id)
        .then((res) => {
          props.documents = [];
          for (var count = 0; count < res.data.length; count++) {
            props.documents.push(res.data[count].title);
          }
        });
    },
    groupDu(props) {
      var array = [];
      var x = groupBy(props, "campusId");
      for (const key in x) {
        array.push({
          campusId: key,
          campus: x[key][0].campus,
          deliveryUnitOptions: x[key]
        });
      }
      return array;
    },
    async getDeliveryUnit() {
      this.$store
        .dispatch("dtsprocesstype/GetDUByProcessType", this.form.processType.id)
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.processTypesDUs = res.data.sort(function(a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.campusOptions = this.groupDu(this.processTypesDUs);
        });
    },
    async getDepartment(duId) {
      this.$store.dispatch("department/GetDepartmentByDU", duId).then((res) => {
        if (res.data.error || res.data.length < 2) {
          return;
        }
        this.departmentOptions = res.data
          .sort(function(a, b) {
            if (a.departmentName < b.departmentName) {
              return -1;
            }
            if (a.departmentName > b.departmentName) {
              return 1;
            }
            return 0;
          })
          .filter((item) => {
            return this.selectedDepartment != item.id;
          });
        this.departmentOptions.unshift({ departmentName: "N/A", id: 0 });
      });
    },
    campusLabel({ campus }) {
      return `${campus}`;
    },
    deliveryUnitLabel({ name }) {
      return `${name}`;
    },
    departmentLabel({ departmentName }) {
      return `${departmentName}`;
    },
    async getProcessType(id) {
      this.$store
        .dispatch("dtsprocesstype/GetProcessTypeParent", id)
        .then((resultParent) => {
          let parentId = resultParent.data.id
            ? resultParent.data.id
            : resultParent.data
            ? resultParent.data
            : null;
          if (parentId) {
            this.$store
              .dispatch("dtsprocesstype/GetProcessTypeChild", parentId)
              .then((resultChildren) => {
                this.processTypeOptions = resultChildren.data.sort(function(
                  a,
                  b
                ) {
                  if (a.processName < b.processName) {
                    return -1;
                  }
                  if (a.processName > b.processName) {
                    return 1;
                  }
                  return 0;
                });
              });
          } else {
            this.$store
              .dispatch("dtsprocesstype/GetProcessTypeChild", id)
              .then((resultChildren) => {
                this.processTypeOptions = resultChildren.data.sort(function(
                  a,
                  b
                ) {
                  if (a.processName < b.processName) {
                    return -1;
                  }
                  if (a.processName > b.processName) {
                    return 1;
                  }
                  return 0;
                });
              });
          }
        });
    },
    processTypeLabel({ processName }) {
      return `${processName}`;
    },
    async getActionType() {
      this.$store.dispatch("dtsactiontype/GetActionType").then((res) => {
        this.actionTypeOptions = res.data.sort(function(a, b) {
          if (a.type < b.type) {
            return -1;
          }
          if (a.type > b.type) {
            return 1;
          }
          return 0;
        });
        this.actionTypeOptions.push({ type: "Others" });
      });
    },
    async refreshOptions() {
      this.formLoading = true;
      await this.getProcessType();
      await this.getActionType();
      if (this.form.processType) {
        await this.getDeliveryUnit();
        if (this.form.destinationCampus) {
          let campusId = this.form.destinationCampus.campusId;
          this.form.destinationCampus = this.campusOptions.find(
            (x) => x.campusId == campusId
          );
        }
      }
      setTimeout(() => {
        this.formLoading = false;
      }, 500);
    },
    actionTypeLabel({ type }) {
      return `${type}`;
    },
    setDateRange() {
      this.processedDateRange = [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      ];
      this.dateRangeIndex = 3;
    },
    selectDate(type) {
      if (type == "Today") {
        this.dateRangeIndex = 0;
        this.$refs.processedDateRange.currentValue = [new Date(), new Date()];
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Yesterday") {
        this.$refs.processedDateRange.currentValue = [
          new Date(Date.now() - 3600 * 1000 * 24),
          new Date(Date.now() - 3600 * 1000 * 24)
        ];
        this.dateRangeIndex = 1;
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Last 7 Days") {
        this.$refs.processedDateRange.currentValue = [
          new Date(Date.now() - 7 * 24 * 3600 * 1000),
          new Date()
        ];
        this.dateRangeIndex = 2;
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "This Month") {
        this.$refs.processedDateRange.currentValue = [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
        ];
        this.dateRangeIndex = 3;
        if (this.$refs.processedDateRange)
          this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Last Month") {
        this.$refs.processedDateRange.currentValue = [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0)
        ];
        this.dateRangeIndex = 4;
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Custom") {
        this.dateRangeIndex = 5;
      }
    },
    processDuration(props) {
      if (props.status != "RECEIVED") return 0;
      var dDate1 = new Date(props.dateTimeReceived);
      var dDate2 = new Date();
      var iWeeks,
        iDateDiff,
        iAdjust = 0;
      if (dDate2 < dDate1) return -1;
      var iWeekday1 = dDate1.getDay();
      var iWeekday2 = dDate2.getDay();
      iWeekday1 = iWeekday1 == 0 ? 7 : iWeekday1;
      iWeekday2 = iWeekday2 == 0 ? 7 : iWeekday2;
      if (iWeekday1 > 5 && iWeekday2 > 5) iAdjust = 1;
      iWeekday1 = iWeekday1 > 5 ? 5 : iWeekday1;
      iWeekday2 = iWeekday2 > 5 ? 5 : iWeekday2;

      iWeeks = Math.floor((dDate2.getTime() - dDate1.getTime()) / 604800000);

      if (iWeekday1 <= iWeekday2) {
        iDateDiff = iWeeks * 5 + (iWeekday2 - iWeekday1);
      } else {
        iDateDiff = (iWeeks + 1) * 5 - (iWeekday1 - iWeekday2);
      }

      iDateDiff -= iAdjust;

      return iDateDiff;
    },
    expectedCompletion(props) {
      var startDate = new Date(props.dateTimeReceived);
      var endDate = "",
        noOfDaysToAdd = props.processType.estimatedWorkingDays,
        count = 0;
      while (count < noOfDaysToAdd) {
        endDate = new Date(startDate.setDate(startDate.getDate() + 1));
        if (endDate.getDay() != 0 && endDate.getDay() != 6) {
          count++;
        }
      }
      return endDate;
    },
    async printTrackingReport() {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      this.tableData.forEach((item) => {
        if (item.selected) body.push({ id: item.id });
      });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Update Notes -->
    <b-modal
      id="modal-updateNotes"
      title="Notes"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <div class="mb-3">
          <textarea
            type="text"
            v-model="formNotes.stringData"
            placeholder="Enter Notes..."
            class="form-control"
            rows="5"
            :class="{
              'is-invalid': submitted && $v.formNotes.stringData.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.formNotes.stringData.$error"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="d-flex float-end">
          <button @click="onUpdateNotes" class="btn btn-primary">Save</button>
        </div>
      </div>
    </b-modal>
    <!-- Return Track -->
    <b-modal
      id="modal-returnTrack"
      title="Return Track"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <div class="mb-3">
          <label for="actionTaken">Remarks </label>
          <textarea
            id="actionTaken"
            type="text"
            v-model="formRemarks.actionTaken"
            placeholder="Enter Remarks..."
            class="form-control"
            :class="{
              'is-invalid':
                submittedDocument && $v.formRemarks.actionTaken.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submittedDocument && $v.formRemarks.actionTaken.$error"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="d-flex float-end">
          <button @click="onReturnTrack" class="btn btn-primary">Return</button>
        </div>
      </div>
    </b-modal>
    <!-- Complete Track -->
    <b-modal
      id="modal-completeTrack"
      title="Complete Track"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <div class="mb-3">
          <label for="actionTaken">Action Taken </label>
          <textarea
            id="actionTaken"
            type="text"
            v-model="formRemarks.actionTaken"
            placeholder="Enter Action Taken..."
            class="form-control"
            :class="{
              'is-invalid':
                submittedDocument && $v.formRemarks.actionTaken.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submittedDocument && $v.formRemarks.actionTaken.$error"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="d-flex float-end">
          <button @click="onCompleteTrack" class="btn btn-primary">
            Submit
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-documentTrack"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="formLoading" class="my-5">
        <div class="d-flex align-items-center justify-content-center">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-25px h-25px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="refreshOptions()"
              class="btn btn-sm btn-info"
            >
              <i class="mdi mdi-refresh"></i>
              Refresh Options
            </button>
          </div>
        </div>
        <div class="mb-3">
          <label for="title">Title </label>
          <input
            id="title"
            type="text"
            v-model="form.title"
            placeholder="Enter Title..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.title.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.title.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.title.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <textarea
            id="description"
            type="text"
            v-model="form.description"
            placeholder="Enter Description..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.description.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.description.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="actionTaken"
            ><div>Action Taken</div>
            <div class="font-size-12">
              <span class="font-size-11">Requested Action:</span>
              {{ form.requestedAction }}
            </div></label
          >
          <textarea
            id="actionTaken"
            type="text"
            v-model="form.actionTaken"
            placeholder="Enter Action Taken..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.actionTaken.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.actionTaken.$error"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label class="mt-2" for="documents">Particulars </label>
          <div>
            <b-input-group>
              <template #append>
                <button @click="addDocument()" class="btn btn-success">
                  Add
                </button>
              </template>
              <input
                autocomplete="off"
                type="text"
                placeholder="Enter Particular..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && form.documents.length == 0
                }"
                v-model="form.document"
                @keyup.enter="addDocument()"
              />
            </b-input-group>
            <div
              v-if="submitted && form.documents.length == 0"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div
            v-if="form.documents.length > 0"
            class="mx-3 mt-2 p-2 br-5 border position-relative"
            style="min-height: 40px; background-color: #2e3446"
          >
            <div
              class="w-100"
              style="top: 10px; left: 10px; bottom: 10px; right: 10px"
            >
              <div class="multiselect__tags-wrap">
                <span
                  class="multiselect__tag"
                  v-for="(document, index) in form.documents"
                  :key="document.id"
                >
                  <span>{{ document }}</span>
                  <i
                    class="multiselect__tag-icon"
                    @click="removeDocument(index)"
                  ></i
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Process </label>
          <multiselect
            id="processType"
            v-model="form.processType"
            track-by="processName"
            label="processName"
            placeholder="Select Process..."
            :custom-label="processTypeLabel"
            :show-labels="false"
            :options="processTypeOptions"
            :searchable="true"
            :multiple="false"
            :allow-empty="false"
            :close-on-select="true"
            :class="{
              'is-invalid': submitted && $v.form.processType.$error
            }"
            @input="changeProcessType()"
          >
          </multiselect>
          <div
            v-if="submitted && $v.form.processType.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.processType.required"
              >This value is required.</span
            >
          </div>
        </div>
        <b-collapse :visible="form.processType != null">
          <div v-if="form.processType != null">
            <div class="mb-3">
              <label>Action Requested/Purpose </label>
              <multiselect
                id="actionType"
                v-model="form.actionType"
                track-by="type"
                label="type"
                placeholder="Select Action Requested/Purpose..."
                :custom-label="actionTypeLabel"
                :show-labels="false"
                :options="actionTypeOptions"
                :searchable="true"
                :multiple="false"
                :allow-empty="false"
                :close-on-select="true"
                :class="{
                  'is-invalid': submitted && $v.form.actionType.$error
                }"
              >
              </multiselect>
              <b-collapse
                :visible="form.actionType && form.actionType.type == 'Others'"
              >
                <div
                  v-if="form.actionType && form.actionType.type == 'Others'"
                  class="mx-3 mt-2"
                >
                  <input
                    id="title"
                    type="text"
                    v-model="form.actionNeeded"
                    placeholder="Enter Action Requested/Purpose..."
                    class="form-control"
                    :class="{
                      'is-invalid':
                        submitted &&
                        form.actionType.type == 'Others' &&
                        form.actionNeeded == ''
                    }"
                    autocomplete="off"
                  />
                </div>
              </b-collapse>
              <div
                v-if="
                  submitted &&
                    ($v.form.actionType.$error ||
                      (form.actionType.type == 'Others' &&
                        form.actionNeeded == ''))
                "
                class="invalid-feedback"
              >
                <span v-if="!$v.form.actionType.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <label>Destination </label>
            <div class="border mb-3 px-3 py-2" style="border-radius: 5px">
              <div class="mb-3">
                <div class="d-flex justify-content-between">
                  <label for="destinationCampus">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
                  <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                        type="checkbox"
                        id="showAll"
                        class="form-check-input"
                        v-model="showAllCampus"
                    />
                    <label
                        for="showAll"
                        class="form-check-label no-wrap"
                    >
                        Show All
                    </label>
                  </div>
                </div>
                <multiselect
                  id="destinationCampus"
                  v-model="form.destinationCampus"
                  track-by="campus"
                  label="campus"
                  :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`"
                  :custom-label="campusLabel"
                  :show-labels="false"
                  :options="campusOptions"
                  :searchable="true"
                  :multiple="false"
                  :allow-empty="false"
                  :close-on-select="true"
                  :class="{
                    'is-invalid': submitted && $v.form.destinationCampus.$error
                  }"
                >
                </multiselect>
                <div
                  v-if="submitted && $v.form.destinationCampus.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.destinationCampus.required"
                    >This value is required.</span
                  >
                </div>
              </div>
              <b-collapse :visible="form.destinationCampus != null">
                <div v-if="form.destinationCampus != null">
                  <div class="mb-3">
                    <label for="destinationDeliveryUnit">Office </label>
                    <multiselect
                      id="destinationDeliveryUnit"
                      v-model="form.destinationDeliveryUnit"
                      track-by="name"
                      label="name"
                      placeholder="Select Office..."
                      :custom-label="deliveryUnitLabel"
                      :show-labels="false"
                      :options="form.destinationCampus.deliveryUnitOptions"
                      :searchable="true"
                      :multiple="false"
                      :allow-empty="false"
                      :close-on-select="true"
                      @input="getDepartment(form.destinationDeliveryUnit.id)"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.destinationDeliveryUnit.$error
                      }"
                    >
                    </multiselect>
                    <div
                      v-if="submitted && $v.form.destinationDeliveryUnit.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.destinationDeliveryUnit.required"
                        >This value is required.</span
                      >
                    </div>
                  </div>
                  <b-collapse :visible="form.destinationDeliveryUnit != null">
                    <div v-if="form.destinationDeliveryUnit != null">
                      <div class="mb-2">
                        <label>Department </label>
                        <multiselect
                          id="destinationDepartment"
                          v-model="form.destinationDepartment"
                          track-by="departmentName"
                          label="departmentName"
                          placeholder="Select Department..."
                          :custom-label="departmentLabel"
                          :show-labels="false"
                          :options="departmentOptions"
                          :searchable="true"
                          :multiple="false"
                          :allow-empty="false"
                          :close-on-select="true"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-collapse>
        <div class="d-flex float-end gap-1">
          <button @click="onForwardTrack('create')" class="btn btn-primary">
            Create as Draft
          </button>
          <button @click="onForwardTrack('send')" class="btn btn-success">
            Create & Send
          </button>
        </div>
      </div>
    </b-modal>
    <!-- Main -->
    <div class="row">
      <b-tabs
        content-class="text-muted"
        v-model="tabIndex"
        nav-class="nav-tabs-custom"
      >
        <!-- Incoming -->
        <b-tab
          @click="
            getIncoming();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Incoming</span>
          </template>
          <div v-if="tabIndex == 0" class="pt-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="currentPage = 1"
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-5 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-3 cursor-pointer"
                      @click="sortData('processType')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'processType'
                        }"
                        >Process Type<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.processReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-3 cursor-pointer"
                      @click="sortData('sentBy')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'sentBy' }"
                        >Sent By<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.sentByReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div class="col-1 text-end">
                      <b>Actions</b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-5">
                        <div>{{ x.referenceNumber }}</div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-green"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewAttachments(x)"
                              >
                                View Attachments
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div>
                          {{ x.processType.processName }}
                        </div>
                        <small>
                          {{ x.processType.easeOfDoingBusinessType }}
                        </small>
                      </div>
                      <div class="col-3">
                        <div v-if="!x.department">
                          {{ x.deliveryUnit.name }}
                        </div>
                        <div v-else>
                          {{ x.department.departmentName }} ({{
                            x.deliveryUnit.name
                          }})
                        </div>
                        <small>{{
                          formatDateWithTime(new Date(x.dateTimePosted))
                        }}</small>
                      </div>
                      <div class="col-1">
                        <div class="d-flex justify-content-end">
                          <i
                            class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                            :id="`incoming-popover-${x.id}`"
                            tabindex="0"
                          ></i>
                          <b-popover
                            :target="`incoming-popover-${x.id}`"
                            triggers="click blur"
                            placement="leftbottom"
                            variant="secondary"
                            custom-class="p-0"
                          >
                            <b-list-group class="w-100 fit">
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-success"
                                @click="receiveTrack(x)"
                                ><i
                                  class="bx bx-folder-open font-size-18 me-1"
                                ></i
                                >Receive Track</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-danger"
                                @click="returnTrack(x)"
                                ><i class="bx bx-undo font-size-18 me-1"></i
                                >Return Track</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Received -->
        <b-tab
          @click="
            getReceived();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Received</span>
          </template>
          <div v-if="tabIndex == 1" class="pt-2" style="min-width: 950px">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">List of Tracks</h5>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      @keyup="currentPage = 1"
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                tracks matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div
                      class="col-5 cursor-pointer"
                      @click="sortData('track')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'track' }"
                        >Process Track<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.trackReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('processTrack')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'processTrack'
                        }"
                        >Process Type<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.processReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('sentBy')"
                    >
                      <b :class="{ 'text-white': tableSort.sortBy == 'sentBy' }"
                        >Sent By<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.sentByReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div
                      class="col-2 cursor-pointer"
                      @click="sortData('duration')"
                    >
                      <b
                        :class="{
                          'text-white': tableSort.sortBy == 'duration'
                        }"
                        >Duration<i
                          class="fs-6 ms-3"
                          :class="
                            tableSort.durationReverse
                              ? 'bx bx-caret-up'
                              : 'bx bx-caret-down'
                          "
                        ></i
                      ></b>
                    </div>
                    <div class="col-1 text-end">
                      <b>Actions</b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-5">
                        <div>{{ x.referenceNumber }}</div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-green"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewAttachments(x)"
                              >
                                View Attachments
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small>
                              <a
                                href="javascript: void(0);"
                                @click="updateNotes(x)"
                              >
                                Notes
                              </a>
                              <span
                                v-if="x.note"
                                class="badge bg-danger rounded-pill position-fixed"
                                >!
                              </span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div>
                          {{ x.processType.processName }}
                        </div>
                        <small>
                          {{ x.processType.easeOfDoingBusinessType }}
                        </small>
                      </div>
                      <div class="col-2">
                        <div v-if="!x.department">
                          {{ x.deliveryUnit.name }}
                        </div>
                        <div v-else>
                          {{ x.department.departmentName }} ({{
                            x.deliveryUnit.name
                          }})
                        </div>
                        <small>{{
                          formatDateWithTime(new Date(x.dateTimePosted))
                        }}</small>
                      </div>
                      <div class="col-2">
                        <div>
                          Days since received: (
                          <b
                            :class="
                              x.processType.estimatedWorkingDays <
                              processDuration(x)
                                ? 'text-danger'
                                : x.processType.daysToRemindOfficeProcessor <
                                  processDuration(x)
                                ? 'text-warning'
                                : 'text-success'
                            "
                          >
                            {{ processDuration(x) }}
                          </b>
                          )
                        </div>
                        <div>
                          <small class="p-0 m-0">
                            <span class="text-pink">{{ x.status }}</span> on
                            {{ formatDate(new Date(x.dateTimeReceived)) }}
                          </small>
                        </div>
                        <div>
                          <div class="font-size-10">
                            To be <span class="text-purple">COMPLETED</span> on
                            {{ formatDate(new Date(expectedCompletion(x))) }}
                          </div>
                        </div>
                      </div>
                      <div class="col-1">
                        <div class="d-flex justify-content-end">
                          <i
                            class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                            :id="`received-popover-${x.id}`"
                            tabindex="0"
                          ></i>
                          <b-popover
                            :target="`received-popover-${x.id}`"
                            triggers="click blur"
                            placement="leftbottom"
                            variant="secondary"
                            custom-class="p-0"
                          >
                            <b-list-group class="w-100 fit">
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-success"
                                @click="completeTrack(x)"
                                ><i
                                  class="bx bx-check-circle font-size-18 me-1"
                                ></i
                                >Complete Track</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-info"
                                @click="
                                  forwardTrack({ data: x, type: 'received' })
                                "
                                ><i class="bx bx-send font-size-18 me-1"></i
                                >Forward Track</b-list-group-item
                              >
                              <b-list-group-item
                                button
                                action
                                class="d-flex align-items-center text-danger"
                                @click="returnTrack(x)"
                                ><i class="bx bx-undo font-size-18 me-1"></i
                                >Return Track</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Processed -->
        <b-tab
          @click="
            getProcessed();
            filter = '';
            currentPage = 1;
          "
        >
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Processed</span>
          </template>
          <div v-if="tabIndex == 2" class="row pt-2">
            <div class="col-lg-3">
              <b-card>
                <label>Date Range</label>
                <date-picker
                  ref="processedDateRange"
                  v-model="processedDateRange"
                  :first-day-of-week="1"
                  lang="en"
                  range
                  placeholder="Enter Date Range..."
                >
                  <div
                    v-if="processedDateRange != ''"
                    slot="input"
                    class="form-control"
                  >
                    <div
                      v-if="
                        formatDateShort(new Date(processedDateRange[0])) !=
                          formatDateShort(new Date(processedDateRange[1]))
                      "
                    >
                      {{ formatDateShort(new Date(processedDateRange[0])) }} -
                      {{ formatDateShort(new Date(processedDateRange[1])) }}
                    </div>
                    <div v-else>
                      {{ formatDate(new Date(processedDateRange[0])) }}
                    </div>
                  </div>
                  <template v-slot:sidebar>
                    <div
                      @click="selectDate('Today')"
                      class="py-1 px-2 cursor-pointer"
                      :class="{
                        'date-range-selected': dateRangeIndex == 0
                      }"
                    >
                      Today
                    </div>
                    <div
                      @click="selectDate('Yesterday')"
                      class="py-1 px-2 cursor-pointer"
                      :class="{
                        'date-range-selected': dateRangeIndex == 1
                      }"
                    >
                      Yesterday
                    </div>
                    <div
                      @click="selectDate('Last 7 Days')"
                      class="py-1 px-2 cursor-pointer"
                      :class="{
                        'date-range-selected': dateRangeIndex == 2
                      }"
                    >
                      Last 7 Days
                    </div>
                    <div
                      @click="selectDate('This Month')"
                      class="py-1 px-2 cursor-pointer"
                      :class="{
                        'date-range-selected': dateRangeIndex == 3
                      }"
                    >
                      This Month
                    </div>
                    <div
                      @click="selectDate('Last Month')"
                      class="py-1 px-2 cursor-pointer"
                      :class="{
                        'date-range-selected': dateRangeIndex == 4
                      }"
                    >
                      Last Month
                    </div>
                    <div
                      @click="selectDate('Custom')"
                      class="py-1 px-2 cursor-pointer"
                      :class="{
                        'date-range-selected': dateRangeIndex == 5
                      }"
                    >
                      Custom
                    </div>
                  </template>
                  <template v-if="dateRangeIndex != 5" v-slot:content>
                    {{ null }}
                  </template>
                </date-picker>
                <button
                  type="button"
                  @click="getProcessed"
                  class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mt-3 mb-1"
                >
                  <i class="bx bx-download fs-6 me-2"></i>Get Track
                </button>
              </b-card>
            </div>
            <div class="col-lg-9">
              <div style="min-width: 950px">
                <div
                  class="d-flex align-items-center justify-content-between mb-3"
                >
                  <h5 class="mb-0">List of Tracks</h5>
                  <div class="d-flex align-items-center">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input
                          autocomplete="off"
                          @keyup="currentPage = 1"
                          v-model="filter"
                          type="search"
                          placeholder="Search Track..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
                <b-card v-if="loading">
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-25px h-25px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <h5 class="mb-0">Loading...</h5>
                  </div>
                </b-card>
                <b-card class="text-center" v-else-if="paginated.length == 0">
                  <div v-if="filter != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no
                    tracks matching your request
                  </div>
                  <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No tracks
                    available
                  </div>
                </b-card>
                <div v-else class="text-muted">
                  <b-card no-body class="m-0 mb-3">
                    <b-card-header>
                      <div class="row align-items-center">
                        <div
                          class="col-6 cursor-pointer"
                          @click="sortData('track')"
                        >
                          <b
                            :class="{
                              'text-white': tableSort.sortBy == 'track'
                            }"
                            >Process Track<i
                              class="fs-6 ms-3"
                              :class="
                                tableSort.trackReverse
                                  ? 'bx bx-caret-up'
                                  : 'bx bx-caret-down'
                              "
                            ></i
                          ></b>
                        </div>
                        <div
                          class="col-3 cursor-pointer"
                          @click="sortData('sentBy')"
                        >
                          <b
                            :class="{
                              'text-white': tableSort.sortBy == 'sentBy'
                            }"
                            >Sent By<i
                              class="fs-6 ms-3"
                              :class="
                                tableSort.sentByReverse
                                  ? 'bx bx-caret-up'
                                  : 'bx bx-caret-down'
                              "
                            ></i
                          ></b>
                        </div>
                        <div class="col-2">
                          <b>Processed On</b>
                        </div>
                        <div class="col-1 text-end">
                          <b>Actions</b>
                        </div>
                      </div>
                    </b-card-header>
                  </b-card>
                  <div
                    role="tablist"
                    v-for="(x, index) in paginated"
                    :key="x.id"
                  >
                    <div class="position-relative ms-1">
                      <RawData
                        :data="x"
                        v-if="$store.state.decrypt.isAdmin()"
                        :style="`z-index: ${paginated.length - index + 11}`"
                      />
                    </div>
                    <b-card
                      no-body
                      class="m-0 mb-3"
                      :style="`z-index: ${paginated.length - index + 10}`"
                    >
                      <b-card-header>
                        <div class="row">
                          <div class="col-6">
                            <div>{{ x.referenceNumber }}</div>
                            <b class="text-white">{{ x.title }}</b>
                            <div class="d-flex align-items-center">
                              <div>
                                <small
                                  ><a
                                    href="javascript: void(0);"
                                    class="text-info"
                                    @click="viewDetails(x.id)"
                                  >
                                    View Details
                                  </a>
                                </small>
                              </div>
                              <span class="mx-2">|</span>
                              <div>
                                <small
                                  ><a
                                    href="javascript: void(0);"
                                    class="text-green"
                                    @click="viewLogs(x.id)"
                                  >
                                    View Logs
                                  </a>
                                </small>
                              </div>
                              <span class="mx-2">|</span>
                              <div>
                                <small
                                  ><a
                                    href="javascript: void(0);"
                                    class="text-warning"
                                    @click="viewAttachments(x)"
                                  >
                                    View Attachments
                                  </a>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div v-if="!x.department">
                              {{ x.deliveryUnit.name }}
                            </div>
                            <div v-else>
                              {{ x.department.departmentName }} ({{
                                x.deliveryUnit.name
                              }})
                            </div>
                            <small>{{
                              formatDateWithTime(new Date(x.dateTimePosted))
                            }}</small>
                          </div>
                          <div class="col-2">
                            <div>
                              {{
                                formatDateWithTime(new Date(x.actionDateTime))
                              }}
                            </div>
                          </div>
                          <div class="col-1">
                            <div class="d-flex justify-content-end">
                              <i
                                class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                :id="`received-popover-${x.id}`"
                                tabindex="0"
                              ></i>
                              <b-popover
                                :target="`received-popover-${x.id}`"
                                triggers="click blur"
                                placement="leftbottom"
                                variant="secondary"
                                custom-class="p-0"
                              >
                                <b-list-group class="w-100 fit">
                                  <b-list-group-item
                                    button
                                    action
                                    class="d-flex align-items-center text-info"
                                    @click="
                                      forwardTrack({
                                        data: x,
                                        type: 'completed'
                                      })
                                    "
                                    ><i class="bx bx-send font-size-18 me-1"></i
                                    >Forward Track</b-list-group-item
                                  >
                                  <b-list-group-item
                                    v-if="!x.withRating"
                                    button
                                    action
                                    class="d-flex align-items-center text-warning"
                                    @click="trackRating(x.id)"
                                    ><i
                                      class="bx bx-check-circle font-size-18 me-1"
                                    ></i
                                    >Rate Track</b-list-group-item
                                  >
                                </b-list-group>
                              </b-popover>
                            </div>
                          </div>
                        </div>
                      </b-card-header>
                    </b-card>
                  </div>
                </div>
                <div class="row">
                  <div v-if="rows > 0" class="col">
                    Showing {{ (currentPage - 1) * perPage + 1 }} -
                    {{
                      rows > (currentPage - 1) * perPage + perPage
                        ? (currentPage - 1) * perPage + perPage
                        : rows
                    }}
                    of {{ rows }}
                  </div>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul
                        class="pagination pagination-rounded mb-0"
                        style="z-index: -1"
                      >
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <Details
      :user="viewDetailsUser"
      @returnTrack="returnTrack($event)"
      @receiveTrack="receiveTrack($event)"
      @completeTrack="completeTrack($event)"
      @forwardTrack="forwardTrack($event)"
      @trackRating="trackRating($event)"
      @printTrackingReport="printSingleTrackingReport($event)"
      ref="details"
    ></Details>
    <Logs @viewDetails="viewDetails($event)" ref="logs"></Logs>
    <Rating ref="rating" @saveRating="saveRating($event)"></Rating>
    <print-options ref="printOpt"></print-options>
    <attachment-modal :wActions="false" :title="uploadTitle" ref="attachmentModal"></attachment-modal>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.mx-datepicker-sidebar {
  padding: 0;
}

.date-range-selected {
  background: #1284e7;
  color: #fff;
}

.slide-enter-active {
  animation: slide-in 0.3s;
}

.slide-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.multiselect__option--group {
  padding-top: 16px;
  padding-bottom: 0;
  background: #2a3042 !important;
  color: #bfc8e2 !important;
  font-weight: bold !important;
  font-size: medium !important;
}

.my-actions {
  padding: 10px 0 0 0;
  font-size: 12px;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.left-gap {
  margin-left: auto;
}
</style>